/* src/components/quickscan-create-update-category-modal/quickscan-create-update-category-modal.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=quickscan-create-update-category-modal.component-LBJW4DYD.css.map */
